import { SNETButton, SNETTextfield, AlertBox, alertTypes } from "shared/dist/components";
import classes from "./DaemonTab.module.css";
import { useTheme } from "@mui/material";
import AuthorizationFieldsEditor from "../../../../../Components/HaaS/Components/MyDeployments/Dialogs/EditDaemonConfigDialog/AuthorizationFieldsEditor";
import { useState, useCallback } from "react";
import clsx from "clsx";
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import { initiateDaemon } from "../../../../../Services/Redux/actionCreators/aiServiceDetailsActions";
import { DAEMON_STATUS } from "../../../../../Utils/Daemon/HaaS/statusesConstant";
import { InitiatedDummy } from "../InitiatedDummy";
import validator from "shared/dist/utils/validator";

const EMPTY_AUTHORIZATION_FIELDS = [];

export const DaemonTab = ({ hasDaemon }) => {
    const dispatch = useDispatch();
    const { orgId, serviceId, isSetupDaemon } = useSelector(
        (state) => ({
            orgId: state.organization.id,
            serviceId: state.aiServiceDetails.id,
            isSetupDaemon:
                !state.aiServiceDetails?.daemon?.status ||
                state.aiServiceDetails?.daemon?.status === DAEMON_STATUS.INIT,
        }),
        shallowEqual
    );

    const [serviceEndpoint, setServiceEndpoint] = useState("");
    const [serviceEndpointValidation, setServiceEndpointValidation] = useState();

    const [editedAuthorizationFields, setEditedAuthorizationFields] = useState([]);
    const [authorizationFieldsError, setAuthorizationFieldsError] = useState(false);
    const [error, setError] = useState();

    const handleValidation = (isInvalid, setterValidation, errorMessage = isInvalid) => {
        if (isInvalid) {
            setterValidation({ type: alertTypes.ERROR, message: errorMessage });
            return false;
        }
        setterValidation();
        return true;
    };

    const theme = useTheme();

    const handleAuthorizationFieldsChange = useCallback(({ fields, hasError }) => {
        setError();
        setEditedAuthorizationFields(fields);
        setAuthorizationFieldsError(hasError);
    }, []);

    const onInitiateDeployment = useCallback(async () => {
        try {
            setError();
            await dispatch(
                initiateDaemon({
                    orgId,
                    serviceId,
                    serviceEndpoint,
                    serviceCredentials: editedAuthorizationFields,
                })
            );
        } catch (error) {
            setError(error?.message || error?.toString());
        }
    }, [dispatch, orgId, serviceId, serviceEndpoint, editedAuthorizationFields]);

    const handleDaemonEndpointChange = (event) => {
        const value = event.target.value;
        const invalidEndPointMessage = validator.validators.validURL(value, {
            message: `Is not a valid endpoint`,
        });
        handleValidation(invalidEndPointMessage, setServiceEndpointValidation);
        setServiceEndpoint(value);
    };

    const isValid =
        !validator.validators.validURL(serviceEndpoint, {}) && !authorizationFieldsError;

    if (hasDaemon) {
        return (
            <div className={clsx(classes.content)}>
                <InitiatedDummy
                    title="Daemon already initialized!"
                    description="Your Daemon is already deployed and running."
                />
            </div>
        );
    }
    return (
        <>
            <div className={classes.content}>
                <p className={classes["accent-info"]}>Daemon hosting is absolutely free!</p>
                <SNETTextfield
                    type="text"
                    name="endpoint"
                    id="endpoint"
                    className="service-endpoint-input"
                    value={serviceEndpoint}
                    onChange={handleDaemonEndpointChange}
                    label="Service Endpoint"
                    error={serviceEndpointValidation}
                    sx={{
                        "& .MuiInputBase-input": {
                            color: theme.primitiveTokens.palette.main.black,
                            letterSpacing: "0.15px",
                        },
                    }}
                />
                <div className={classes["service-authorization-container"]}>
                    <h3>Authorization</h3>
                    <AuthorizationFieldsEditor
                        originalAuthorizationFields={EMPTY_AUTHORIZATION_FIELDS}
                        onChange={handleAuthorizationFieldsChange}
                    />
                </div>
                <div className="daemon-config-modal-footer">
                    <p className="authorization-info">
                        Authorization for your service. Don't worry about security, data is
                        encrypted for transmission. Leave the fields blank if your service does not
                        have authorization.
                    </p>
                    {!isSetupDaemon && (
                        <div className="error-holder">
                            <AlertBox
                                type={alertTypes.WARNING}
                                message="
        Warning! If you leave the authorization fields empty when updating the config,
        the previous values will be lost!
        "
                            />
                        </div>
                    )}
                    <div className="error-holder">
                        <AlertBox type={alertTypes.ERROR} message={error} />
                    </div>
                </div>
            </div>
            <SNETButton
                className={classes.button}
                disabled={!isValid}
                onClick={onInitiateDeployment}
            >
                INITIATE DEPLOYMENT
            </SNETButton>
        </>
    );
};
